import type { GetUserNetworksForContextMenuQueryVariables } from '@/graphql/api/generated'

/**
 * Same variables as UserMenu > "Changer de contexte" (enabled networks for switching).
 * Refetch this after mutations that change network list or disabled state; otherwise Apollo
 * keeps a separate cache entry from paginated MyNetworks queries.
 */
export const GET_USER_NETWORKS_USER_MENU_VARIABLES: GetUserNetworksForContextMenuQueryVariables =
  Object.freeze({
    first: 100,
    disabled: false,
  })
